export * from './live-chat.component';



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/live-chat/index.ts